import React, { useState, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import axios from 'axios';
import storage from '../utils/storage';
import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';

const SyncForeCourtConfig = ({ tooltipText = "Sync Forecourt Configuration", toast, onSuccess, storeId, tmplId }) => {

    const [isDialogVisible, setIsDialogVisible] = useState(false);
    const downloadIconRef = useRef(null);

    const formik = useFormik({
        initialValues: {
            storeId: storeId || '',
            tmplId: tmplId || '',
        },
        validate: (data) => {
            let errors = {};
            if (!data.tmplId) {
                errors.tmplId = 'Template ID is required.';
            }
            if (!data.storeId) {
                errors.storeId = 'Store ID is required.';
            }
            return errors; // Ensure errors are returned
        },
        onSubmit: (values) => {
            const data = {
                ...values,
            };
            handleDialogConfirm(data);
        }
    });

    const handleDialogConfirm = async (payload) => {
        const token = storage.getToken();
        const URL = window?.config?.END_POINT;
    
        try {
            const response = await axios.post(`${URL}/sys/propconfig/sync-fore-court-config`, payload, {
                headers: { Authorization: token }
            });
    
            if (response.status === 200) {
                toast?.current?.show({ severity: 'success', summary: 'Success', detail: response?.data?.message || 'Synced successfully' });
                formik.resetForm();
                if (onSuccess) {
                    onSuccess();  // 🔔 Call the success callback
                }
            } else {
                toast?.current?.show({ severity: 'error', summary: 'Error', detail: response?.data?.message || 'Synced failed' });
            }
        } catch (error) {
            console.error("API call error:", error);
            toast?.current?.show({ severity: 'error', summary: 'Error', detail: error?.response?.data?.message || error.message });
        }
    
        setIsDialogVisible(false);
    };
    

    return (
        <>
            <Button
                type="button"
                icon="pi pi-sync"
                severity="info"
                className='tp'
                outlined
                label="Sync Forecourt Configuration"
                ref={downloadIconRef}
                onClick={() => setIsDialogVisible(true)}
                data-pr-tooltip={tooltipText}
            />

            <Dialog
                header="Forecourt Configuration"
                visible={isDialogVisible}
                style={{ width: '30vw' }}
                onHide={() => setIsDialogVisible(false)}
                footer={
                    <div>
                        <Button label="Cancel" outlined severity="secondary" icon='pi pi-times' onClick={() => setIsDialogVisible(false)} />
                        <Button label="Submit" outlined onClick={formik.handleSubmit} icon='pi pi-save' className="p-button-success mr-2" />
                    </div>
                }
            >
                <div className="grid p-2 mt-3">
                    <div className="p-fluid formgrid grid w-full">

                        <div className="field col-12">
                            <label htmlFor="storeId">Store ID</label>
                            <InputText
                                id="storeId"
                                name="storeId"
                                value={formik.values.storeId}
                                onChange={(e) => formik.setFieldValue('storeId', e.target.value)}
                                placeholder="Store ID"
                                className={formik.errors.storeId && formik.touched.storeId ? 'p-invalid' : ''}
                            />
                            {formik.errors.storeId && formik.touched.storeId && (
                                <small className="p-error">{formik.errors.storeId}</small>
                            )}
                        </div>

                        <div className="field col-12">
                            <label htmlFor="tmplId">Template ID</label>
                            <InputText
                                id="tmplId"
                                name="tmplId"
                                value={formik.values.tmplId}
                                onChange={(e) => formik.setFieldValue('tmplId', e.target.value)}
                                placeholder="Template ID"
                                className={formik.errors.tmplId && formik.touched.tmplId ? 'p-invalid' : ''}
                            />
                            {formik.errors.tmplId && formik.touched.tmplId && (
                                <small className="p-error">{formik.errors.tmplId}</small>
                            )}
                        </div>

                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default SyncForeCourtConfig;